<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style  lang="scss" src="@/assets/style/common.scss"></style>



// WEBPACK FOOTER //
// src/pages/App.vue